import * as Models from "../.";
import { InverterTypeModel } from "../SystemDetails/index";

export interface ISystem {
  systemId: number;
  rollingAnnualProduction: number;
  systemSize: number;
  stage: number;
  stageStatus: string;
  installStartDate: Date;
  installCompleteDate: Date;
  ptoDate: Date;
  proposedPtoDate: Date;
  stateCertificateCode: string;
  uccFilingCode: string;
  monitoringIdentificationCode: string;
  createDtae: Date;
  createBy: string;
  modifyDate: Date;
  modifyBy: string;
  systemComponents: Models.Customer.SystemComponent.SystemComponent[];
  arrayDataDetails: Models.SystemDetails.ArrayData.ArrayData[];
  arrayAverageInformation: Models.SystemDetails.ArrayAverageInformation.ArrayAverageInformation;
  inverterType: InverterTypeModel.InverterTypeModel;
  hasSystem: boolean;
  p50AnnualProduction: number;
  isLineTrenchingRequired: boolean;
  systemIncentives: Models.Customer.SystemIncentive.ISystemIncentive[];
}

export class System implements ISystem {
  public systemId: number;
  public rollingAnnualProduction: number;
  public systemSize: number;
  public stage: number;
  public stageStatus: string;
  public installStartDate: Date;
  public installCompleteDate: Date;
  public ptoDate: Date;
  public proposedPtoDate: Date;
  public stateCertificateCode: string;
  public uccFilingCode: string;
  public monitoringIdentificationCode: string;
  public createDtae: Date;
  public createBy: string;
  public modifyDate: Date;
  public modifyBy: string;
  public systemComponents: Models.Customer.SystemComponent.SystemComponent[];
  public arrayDataDetails: Models.SystemDetails.ArrayData.ArrayData[];
  public arrayAverageInformation: Models.SystemDetails.ArrayAverageInformation.ArrayAverageInformation;
  public inverterType: Models.SystemDetails.InverterTypeModel.InverterTypeModel;
  public hasSystem: boolean;
  public p50AnnualProduction: number;
  public isLineTrenchingRequired: boolean;
  public systemIncentives: Models.Customer.SystemIncentive.ISystemIncentive[];
  public mountingTypeName: string;
}
